import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBps, FctValue } from '../../../../Fct/generics';
import { POOL_ADDRESSES } from '../constants';
export var GetUserAccountData = createPlugin({
    protocol: 'AaveV3',
    type: 'GETTER',
    method: 'getUserAccountData',
    supportedContracts: POOL_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'aave_pool_v3' }),
                methodParams: {
                    user: new FctAddress({}),
                },
            },
            output: {
                totalCollateralBase: new FctValue({ innerIndex: 0 }),
                totalDebtBase: new FctValue({ innerIndex: 1 }),
                availableBorrowsBase: new FctValue({ innerIndex: 2 }),
                currentLiquidationThreshold: new FctBps({ innerIndex: 3 }),
                ltv: new FctBps({ innerIndex: 4 }),
                healthFactor: new FctValue({ innerIndex: 5 }),
            },
        });
    },
});
